module.exports = __webpack_public_path__ + "images/131_320.jpg";